import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN } from 'common/userRoles';
import H1 from 'client/components/H1';
import SrLogo from 'client/components/SrLogo';
import SrPinnedListingForm from 'client/components/SrPinnedListingForm';

import branch from 'client/core/branch';

import { SCREEN_ID_ADMIN_PINNED_LISTINGS } from 'client/constants/screenIds';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';

import AdminActions from 'client/actions/Admin';
import { SR_API_ACTION_ADMIN_UPDATE_ITEM } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';

const actionQueryId = 'listingNotAvailable';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_PINNED_LISTINGS)
@withScrollToTop
@withApiState({
  listingPinnedApiState: {
    action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
    queryId: actionQueryId,
  },
})
@branch({
  pinnedListings: ['pinnedListings'],
})
class AdminPinnedListingsPage extends Component {
  static fetchData(state, inject) {
    return AdminActions.getPinnedListings(inject);
  }

  static getPageMetadata = () => ({
    pageTitle: 'Admin Pinned Listings | Sunroom Rentals',
    section: 'Admin',
  });

  static propTypes = {
    pinnedListings: PropTypes.array,
  };

  _onTogglePinnedListing = (pinnedListingPayload) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_UPDATE_ITEM,
      payload: {
        table: 'listings',
        where: {
          id: pinnedListingPayload.listingId,
        },
        updates: {
          pinned: pinnedListingPayload.pinned,
        },
        queryId: actionQueryId,
      },
    }).then(() => {
      dispatch(AdminActions.getPinnedListings);
    });
  };

  render() {
    const { listingPinnedApiState, pinnedListings } = this.props;

    return (
      <div className="page-tourSupportDashboard">
        <div className="admin-navbar clearfix">
          <div className="logo-container">
            <SrLogo redirectTo="/admin" />
          </div>
          <div className="admin-navbar-links-container" />
        </div>
        <H1>Pinned Listings</H1>
        <div className="adminContainer pinned-listings-container">
          {pinnedListings && (
            <SrPinnedListingForm
              listings={pinnedListings}
              onTogglePinnedListing={this._onTogglePinnedListing}
              disabled={listingPinnedApiState.inProgress}
            />
          )}
        </div>
      </div>
    );
  }
}

AdminPinnedListingsPage.displayName = 'AdminPinnedListingsPage';

export default AdminPinnedListingsPage;
